import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/package-prototype-jobs',
        name: 'packagePrototypeJobs',
        component: () => import('@/views/PackagePrototypeJobs/Index.vue'),
        meta: {
            title: 'packagePrototypeJobs.pageTitle',
            menuRendered: true,
            menuTitle: 'packagePrototypeJobs.menuTitle',
            requiresAuth: true,
            permission: 'prototypes',
            icon: 'mdi-package-variant'
        }
    },
    {
        path: '/package-prototype-jobs/:id',
        name: 'packagePrototypeJob',
        component: () => import('@/views/PackagePrototypeJobs/Detail/Index.vue'),
        meta: {
            title: 'packagePrototypeJobs.detail.pageTitle',
            menuRendered: false,
            requiresAuth: true,
            permission: 'prototypes'
        }
    }
]

export default routes
